<template>
  <div class="card">
    <div class="card-header" :id="'heading' + groupName">
      <h5 class="mb-0">
        <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse' + groupName" aria-expanded="true" :aria-controls="'collapse' + groupName">
          {{groupLabel}}
        </button>
      </h5>
      <div class="text-right">
        <span v-if="timeline.time"><i class="micon-clock"></i> <span v-if="timeline.time.minutes">{{ timeline.time.minutes }} minutos</span> {{ timeline.time.seconds }} segundos</span>
      </div>
    </div>

    <div :id="'collapse' + groupName" class="collapse" :aria-labelledby="'heading' + groupName" data-parent="#accordion">
      <div class="card-body">
        <timeline-item-component v-for="(h, index) in timeline.data" v-bind:key="h.id" :row="h" :index="index" :length="timeline.data.length" :groupName="groupName"></timeline-item-component>
      </div>
    </div>
  </div>
</template>
<script>
import TimelineItem from '../../partial/timeline/TimelineItem.vue'

export default {
  props: ['timeline', 'groupName', 'groupLabel'],
  components: {
    'timeline-item-component': TimelineItem
  }
}
</script>
<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/partial/timeline/TimelineGroup.vue